import { apiRequest } from './client.js';

type Tok = string | null | undefined;

const BASE = '/v1/m17/config/planning-cycles';

export interface PlanningCycleRow {
  readonly planningCycleId: string;
  readonly cycleCode: string;
  readonly cycleName: string;
  readonly description: string | null;
  readonly startMonth: number;
  readonly startYear: number;
  readonly endMonth: number;
  readonly endYear: number;
  readonly recordStatusCode: string;
}

export interface CreatePlanningCycleInput {
  readonly cycleCode: string;
  readonly cycleName: string;
  readonly description?: string;
  readonly startMonth: number;
  readonly startYear: number;
  readonly endMonth: number;
  readonly endYear: number;
}

export function listPlanningCycleRows(
  token: Tok,
  page = 1,
  limit = 100,
): Promise<{ data: readonly PlanningCycleRow[]; total: number }> {
  return apiRequest(`${BASE}?page=${page}&limit=${limit}`, { token });
}

export function createPlanningCycle(
  input: CreatePlanningCycleInput,
  token: Tok,
): Promise<PlanningCycleRow> {
  return apiRequest(BASE, { method: 'POST', body: input, token });
}

/** Bounds are immutable once periods hang off the cycle, so only the labels. */
export function updatePlanningCycle(
  id: string,
  input: { cycleName?: string; description?: string },
  token: Tok,
): Promise<PlanningCycleRow> {
  return apiRequest(`${BASE}/${id}`, { method: 'PUT', body: input, token });
}

export function archivePlanningCycle(id: string, token: Tok): Promise<void> {
  return apiRequest(`${BASE}/${id}/archive`, { method: 'POST', token });
}

export function reactivatePlanningCycle(id: string, token: Tok): Promise<PlanningCycleRow> {
  return apiRequest(`${BASE}/${id}/reactivate`, { method: 'POST', token });
}
